"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAdd = void 0;

var React = __importStar(require("react"));

exports.IconAdd = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M20 39.1688C14.908 39.1688 10.0248 37.1454 6.42359 33.544C2.82359 29.944 0.799988 25.0612 0.799988 19.9688C0.799988 14.8764 2.82343 9.9924 6.42359 6.3924C10.0251 2.79084 14.908 0.768799 20 0.768799C25.092 0.768799 29.9752 2.79068 33.5764 6.3924C37.1764 9.9924 39.2 14.8768 39.2 19.9688C39.1937 25.058 37.1687 29.9376 33.5688 33.5376C29.9703 37.1376 25.0908 39.1612 20 39.1688ZM20 3.1688C15.5436 3.1688 11.272 4.93756 8.12039 8.0892C4.97039 11.2392 3.19999 15.5128 3.19999 19.9688C3.19999 24.4236 4.97031 28.6968 8.12039 31.8468C11.2719 34.9984 15.544 36.7688 20 36.7688C24.456 36.7688 28.728 34.9985 31.8796 31.8468C35.0296 28.6968 36.8 24.4232 36.8 19.9688C36.8 15.5124 35.0297 11.2392 31.8796 8.0892C28.728 4.93764 24.456 3.1688 20 3.1688V3.1688Z",
    fill: color
  }), React.createElement("path", {
    d: "M27.5627 18.5665H21.4392V12.4373C21.4392 11.6438 20.7954 11 20.0019 11C19.2084 11 18.5646 11.6438 18.5646 12.4373V18.5665H12.4373C11.6438 18.5665 11 19.2084 11 20.0038C11 20.7973 11.6438 21.4412 12.4373 21.4412H18.5646V27.5627C18.5646 28.3562 19.2084 29 20.0019 29C20.7954 29 21.4392 28.3562 21.4392 27.5627V21.4412H27.5627C28.3562 21.4412 29 20.7973 29 20.0038C29 19.2084 28.3562 18.5665 27.5627 18.5665Z",
    fill: color
  }));
});